import { render, staticRenderFns } from "./Marketzodiac.vue?vue&type=template&id=0709383f&scoped=true"
import script from "./Marketzodiac.vue?vue&type=script&lang=js"
export * from "./Marketzodiac.vue?vue&type=script&lang=js"
import style0 from "./Marketzodiac.vue?vue&type=style&index=0&id=0709383f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709383f",
  null
  
)

export default component.exports